import React, { useEffect, useState } from 'react'
import { useTheme } from 'styled-components'
import { MaterialIcon } from '@dsny/dsny-component-library'
import MetaData from '../MetaData/MetaData'
import {
  MetadataTrackItem,
  MetadataTrackHeader,
  MetadataTrackContentCluster,
  MetadataTrackNumber,
  MetadataTrackBody,
  MetadataTrackTitleRow,
  MetadataTrackTitle,
  MetadataTrackArtist,
  MetadataTrackVersion,
  MetadataExpandButton
} from './Track.styles.js'
import useReleaseInformationResponsiveBreakpointsV2 from '../../hooks/useReleaseInformationResponsiveBreakpointsV2'

export default function MetadataTrackRow({
  track = {},
  index = 0,
  isExpanded = false
}) {
  const theme = useTheme()
  const responsiveBreakpointsV2 = useReleaseInformationResponsiveBreakpointsV2()
  const [toggle, setToggle] = useState(isExpanded)

  const trackToggle = () => {
    setToggle((currentToggle) => !currentToggle)
  }

  useEffect(() => {
    setToggle(Boolean(isExpanded))
  }, [isExpanded])

  return (
    <MetadataTrackItem>
      <MetadataTrackHeader
        $responsiveBreakpointsV2={responsiveBreakpointsV2}
        onClick={trackToggle}
        type="button"
      >
        <MetadataTrackContentCluster
          $responsiveBreakpointsV2={responsiveBreakpointsV2}
        >
          <MetadataTrackNumber>{index + 1}</MetadataTrackNumber>
          <MetadataTrackBody>
            <MetadataTrackTitleRow>
              <MetadataTrackTitle>{track?.title}</MetadataTrackTitle>
              {track?.version && (
                <MetadataTrackVersion>{`(${track.version})`}</MetadataTrackVersion>
              )}
            </MetadataTrackTitleRow>
            <MetadataTrackArtist>{track?.artist}</MetadataTrackArtist>
          </MetadataTrackBody>
        </MetadataTrackContentCluster>
        <MetadataExpandButton>
          <MaterialIcon
            name={toggle ? 'ExpandLess' : 'ExpandMore'}
            color={theme.colors.neutralW100}
          />
        </MetadataExpandButton>
      </MetadataTrackHeader>
      {toggle && <MetaData track={track} />}
    </MetadataTrackItem>
  )
}
